import React from 'react'
import PeriodSearch from 'components/molcules/PeriodSearch'
import useToolbarStyles from 'components/Table/useTableToolbarStyles'
import {getDefaultPeriodDate} from 'helpers/dateHelper'
import ToolbarSearch from 'pages/ProductHistoryOrganization/ProductHistoryOrganizationList/ToolbarSearch'

interface TableToolbarProps {
  onChangeDate: (period: PeriodDate) => void
  onSearch: (key: string, value: string) => void
}

const TableToolbar = (props: TableToolbarProps) => {
  const {onChangeDate, onSearch} = props

  const classes = useToolbarStyles()
  const selection = getDefaultPeriodDate()

  const handlePeriod = (period: PeriodDate) => {
    onChangeDate(period)
  }

  return (
    <div>
      <div className={classes.root}>
        <div className={classes.container}>
          <PeriodSearch period={selection} onSearch={handlePeriod} />
          <ToolbarSearch onSearch={onSearch} />
        </div>
      </div>
    </div>
  )
}

export default TableToolbar
